import * as React from 'react';
import styled from 'styled-components';
import { Pagination, theme } from 'components';
import { buildCssProp } from 'utils';
import { PAGE_SIZE } from './constants';
import ManageUsersContext from '../ManageUsersContext';

interface ManageUsersPaginationProps {
  count?: number;
  hidden?: boolean;
  tableName?: string;
}

const ManageUsersPagination: React.FC<ManageUsersPaginationProps> = ({
  count,
  hidden,
  tableName,
}) => {
  const { pageNumber, setPageNumber } = React.useContext(ManageUsersContext);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
  };
  return (
    <StyledPagination
      current={pageNumber}
      onChange={handlePageChange}
      total={count}
      pageSize={PAGE_SIZE}
      showSizeChanger={false}
      responsive
      $hidden={hidden}
      // add dataCy to each pagination element
      itemRender={(page, type, element: any) => ({
        ...element,
        props: {
          ...element.props,
          'data-cy': `${tableName}-${type}-${page}`,
        },
      })}
    />
  );
};

export default ManageUsersPagination;

export const StyledPagination = styled(Pagination)<{ $hidden?: boolean }>`
  border-top: 1px solid ${theme.gray3};
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  ${({ $hidden }) => buildCssProp('visibility', $hidden && 'hidden')}
`;
